import React from "react";

function Intro() {
  return (
    <section className="page-banner">
      <div className="container">
        <div className="page-content-wrapper">
          <h1 className="page-title">Blogs</h1>
          <p className="page-description">Latest from our Blog</p>
        </div>
      </div>
    </section>
  );
}

export default Intro;
